function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _rect, _rect2, _g, _rect3, _circle, _path;
var _excluded = ["width", "height", "originalSize", "top", "bottom", "left", "right"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }
import * as React from "react";
var toUnit = function toUnit(v) {
  return !v || /^([0-9]+(px|em|rem|%)|auto)/.test(v) ? v : v + 'px';
};
var SvgEnvelope = function SvgEnvelope(_ref) {
  var _ref$width = _ref.width,
    width = _ref$width === void 0 ? '35px' : _ref$width,
    _ref$height = _ref.height,
    height = _ref$height === void 0 ? '35px' : _ref$height,
    originalSize = _ref.originalSize,
    top = _ref.top,
    bottom = _ref.bottom,
    left = _ref.left,
    right = _ref.right,
    rest = _objectWithoutProperties(_ref, _excluded);
  var hasStyle = !!top || !bottom || !!right || !!left;
  var style = hasStyle ? {
    marginTop: toUnit(top),
    marginBottom: toUnit(bottom),
    marginRight: toUnit(right),
    marginLeft: toUnit(left)
  } : {};
  var props = originalSize ? _objectSpread(_objectSpread({}, rest), {}, {
    style: style
  }) : _objectSpread(_objectSpread({}, rest), {}, {
    style: style,
    width: toUnit(width),
    height: toUnit(height)
  });
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 94,
    height: 72,
    viewBox: "0 0 94 72",
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 91,
    height: 60,
    x: 1.999,
    y: 11,
    fill: "#FAFAFA",
    rx: 5.166
  })), /*#__PURE__*/React.createElement("mask", {
    id: "envelope_svg__a",
    width: 92,
    height: 60,
    x: 1,
    y: 11,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 91.36,
    height: 59.638,
    x: 1.626,
    y: 11.104,
    fill: "#fff",
    rx: 5.166
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#envelope_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#D0E2F1",
    d: "m43.005 51.876-41.38-33.16-.951-5.71 93.263-.793-.952 6.186-40.182 33.39a7.749 7.749 0 0 1-9.798.087Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FEA09A",
    strokeLinejoin: "round",
    strokeWidth: 1.291,
    d: "M1.626 70.742C15.501 59.345 23.914 52.637 37.789 41.24m55.196 29.502C79.111 59.345 70.697 52.637 56.822 41.24"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FAFAFA",
    stroke: "#FEA09A",
    strokeLinejoin: "round",
    strokeWidth: 1.291,
    d: "M42.735 51.228 1.31 14.592V9.041h91.994v5.551L53.08 51.157a7.749 7.749 0 0 1-10.346.071Z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 75.221,
    cy: 11.421,
    r: 10.151,
    fill: "#D0E2F1"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 91,
    height: 60,
    x: 1.499,
    y: 11.5,
    stroke: "#FEA09A",
    rx: 5.5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 73.953,
    cy: 10.151,
    r: 10.151,
    fill: "#FE5348"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FAFAFA",
    d: "m75.083 6.027-.176 6.462h-1.65l-.18-6.462h2.006Zm-1 9.346c-.298 0-.553-.105-.766-.316a1.03 1.03 0 0 1-.316-.766 1.01 1.01 0 0 1 .316-.757c.213-.21.468-.315.766-.315.285 0 .536.105.752.315a1.034 1.034 0 0 1 .171 1.302 1.17 1.17 0 0 1-.392.393c-.162.096-.34.144-.532.144Z"
  })));
};
export { SvgEnvelope as ReactComponent };
export default "/_next/static/media/envelope.8d7539dd.svg";